import routes from '../_routes/adminRoutes';
import useEnvironment from './useEnvironment';

export default function useAdminRoutes() {
  const { REACT_APP_ADMIN_URL } = useEnvironment();

  function path(routeName: string, params: Record<string, string> = {}) {
    const matchRoutes = routes.filter((route) => route.name === routeName);
    const paramsKeys = Object.keys(params);
    if (matchRoutes.length) {
      let tempPath = '';

      matchRoutes.forEach((route) => {
        let routePath = route.path;
        let pathParams = routePath.match(/:(\w+)/g);

        if (pathParams) {
          pathParams = pathParams.map((match) => match.replace(':', ''));
        }

        // path dont have params || all params match
        if (
          !pathParams ||
          pathParams.filter((i) => paramsKeys.includes(i)).length ===
            pathParams.length
        ) {
          paramsKeys.forEach((key) => {
            routePath = routePath.replace(`:${key}*`, params[key]);
            routePath = routePath.replace(`:${key}`, params[key]);
          });

          tempPath = routePath;
        }
      });
      return `${REACT_APP_ADMIN_URL}${tempPath}`;
    }
    return routeName;
  }

  function getRoute(tmpPath: string, matchParams: Record<string, string>) {
    let originalPath = tmpPath;

    Object.keys(matchParams).forEach((key) => {
      originalPath = originalPath.replace(
        RegExp(matchParams[key], 'g'),
        `:${key}`
      );
    });

    return routes.find(
      (route) =>
        route.path === originalPath || route.path === `${originalPath}*`
    );
  }

  function getRouteName(pathname: string, params: Record<string, string>) {
    const route = getRoute(pathname, params);
    if (route) {
      return route.name;
    }
    // eslint-disable-next-line
    console.error(`cant found route name with path: ${pathname}`);
    return '';
  }

  return {
    getRouteName,
    path,
  };
}
